/* eslint-disable no-console */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

export const envConfig = {
    B2C_AUTH_REDIRECT_URI: process.env.REACT_APP_B2C_AUTH_REDIRECT_URI,
    PROXY_TARGET: process.env.REACT_APP_PROXY_TARGET,
};

export const b2cPolicies = (tenant?: string) => {
    const tenantName = tenant || 'kitronorg';
    return {
        names: {
            signUpSignIn: 'B2C_1a_signup_signin',
            forgotPassword: 'B2C_1_reset_v3',
            editProfile: 'B2C_1_edit_profile_v2',
        },
        authorities: {
            signUpSignIn: {
                authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN`,
            },
            forgotPassword: {
                authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_reset_v3`,
            },
            editProfile: {
                authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/b2c_1_edit_profile_v2`,
            },
        },
        authorityDomain: `${tenantName}.b2clogin.com`,
    };
};

export const msalConfig = (
    clientId?: string,
    redirectUri?: string,
    tenant?: string
) => {
    return {
        auth: {
            clientId: clientId || '6b71e615-c0b6-4c13-a470-f320bfe5e707',
            authority: b2cPolicies(tenant).authorities.signUpSignIn.authority,
            knownAuthorities: [b2cPolicies(tenant).authorityDomain],
            redirectUri: redirectUri || 'http://localhost:3000/oauth2-redirect',
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: (
                    level: number,
                    message: string,
                    containsPii: boolean
                ) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            break;
                        default:
                    }
                },
            },
        },
    };
};

export const loginRequest = (scopes: string[]) => {
    return {
        scopes,
    };
};
